import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { toogleResize } from '../../redux/reducers/resizeSlice';

export const useWindowResize = () => {
    const dispatch = useDispatch();
    const resize = useSelector((state: RootState) => state.resizeSlice); // Corrected type

    useEffect(() => {
        const getResize = () => {
            if (window.innerWidth < 720) {
                dispatch(toogleResize(true));
            } else {
                dispatch(toogleResize(false));
            }
        };

        getResize();

        window.addEventListener('resize', getResize);

        return () => {
            window.removeEventListener('resize', getResize);
        };
    }, [dispatch]);

    return resize;
};